import { render, staticRenderFns } from "./ProductRegisteredSearch.vue?vue&type=template&id=5c1c6bbd&"
import script from "./ProductRegisteredSearch.vue?vue&type=script&lang=js&"
export * from "./ProductRegisteredSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports